<script setup>
import { computed } from 'vue';
import { calendarEventDisplayTime } from '@/js/core/utils/calendar-event-time.js';
import { DEFAULT_TIMEZONE } from '@/js/core/utils/timezone.js';

const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
  timezone: {
    type: String,
    default: DEFAULT_TIMEZONE,
  },
  display: {
    type: String,
    default: 'full',
    validator: value => ['full', 'time', 'timezone'].includes(value),
  },
});

const displayTime = computed(() => calendarEventDisplayTime(props.event, props.timezone));

const isVisible = computed(() => {
  if (props.display === 'timezone') {
    return Boolean(displayTime.value?.timezoneLabel);
  }

  return Boolean(displayTime.value?.label);
});
</script>

<template>
  <span v-if="isVisible">
    <template v-if="props.display === 'timezone'">
      <span>{{ displayTime.timezoneLabel }}</span>
    </template>
    <template v-else>
      {{ displayTime.label }}
      <span v-if="props.display === 'full' && displayTime.timezoneLabel" class="timezone">
        <span>{{ displayTime.timezoneLabel }}</span>
      </span>
    </template>
  </span>
</template>
